module.exports = __webpack_public_path__ + "img/sub_step8.78563996.png";